<div *ngIf="!firstLoad">
  <!-- <div class="seo-ai_analysis-detailed-search">
    <h2 class="seo-ai_analysis-design-v2-headline">
      How <b>{{ selectedProject?.domain }}</b> is performing
    </h2>
  </div> -->
  <div class="seo-ai_analysis-design-v2">
    <div class="design-v2-content-container" style="margin-top: 0 !important">
      <div class="design-v2-cards" style="grid-template-columns: 1fr">
        <div
          class="design-v2-card"
          *ngFor="let model of modelCardsData"
          style="cursor: default !important"
        >
          <!-- (click)="changeModel(model.value)"
          [ngClass]="{ active: model.value == selectedModel }" -->
          <div class="design-v2-card-header">
            <div class="design-v2-card-header-icon">
              <img [src]="model.icon.src" [alt]="model.icon.alt" />
            </div>
            <h3>{{ model.name }}</h3>
          </div>
          <div class="design-v2-card-content">
            <p class="design-v2-card-content-value">
              {{ formatValue(model.score) }} <span>/100</span>
            </p>
            <p class="design-v2-card-content-description">
              {{ model.description }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <div class="design-v2-flex">
      <div class="design-v2-flex-item">
        <h2 class="design-v2-flex-item-headline">Site Strength Overview</h2>
        <div class="design-v2-flex-item-container">
          <div
            class="design-v2-flex-container-item"
            *ngFor="let data of siteStrengthOverviewData"
          >
            <app-progress-chart [progress]="data"></app-progress-chart>
          </div>
        </div>
      </div>
    </div>

    <div
      class="design-v2-flex two-column-container"
      *ngIf="content_score_fixes?.length > 0 || quick_wins_array?.length > 0"
    >
      <div class="design-v2-flex-item" *ngIf="content_score_fixes?.length > 0">
        <h2 class="design-v2-flex-item-headline">
          <i class="fa-solid fa-triangle-exclamation"></i>
          Top Issues:

          <div
            class="custom_horizontal_option_select-container"
            style="position: relative; top: 1px"
          >
            <div
              class="custom_horizontal_option_active"
              [ngStyle]="{
                width: horizontalOptionStylesCategory.width,
                transform: horizontalOptionStylesCategory.transform,
              }"
            ></div>
            <div
              class="custom_horizontal_option_select"
              *ngFor="let item of horizontalOptionsCategory"
              (click)="
                onToggleChangeCategory(
                  $event,
                  item,
                  horizontalOptionStylesCategory
                )
              "
            >
              <p>
                {{ item.viewValue }}
              </p>
            </div>
          </div>
        </h2>
        <div class="design-v2-flex-quick-fixes">
          <div
            class="design-v2-flex-quick-fixes-item second-style"
            *ngFor="let fix of content_score_fixes"
          >
            <div class="design-v2-flex-quick-fixes-item-icon">
              <i class="fa fa-solid fa-circle-exclamation"></i>
            </div>
            <div class="design-v2-flex-quick-fixes-item-text">
              <h3>{{ fix.name_formatted }}</h3>
              <p>{{ fix.description_formatted }}</p>
            </div>
          </div>
        </div>
      </div>
      <div class="vertical-line" *ngIf="quick_wins_array?.length > 0"></div>
      <div class="design-v2-flex-item" *ngIf="quick_wins_array?.length > 0">
        <h2 class="design-v2-flex-item-headline">
          <i class="fa-solid fa-lightbulb"></i>
          Quick Wins
        </h2>
        <div class="design-v2-flex-quick-fixes">
          <div
            class="design-v2-flex-quick-fixes-item second-style"
            *ngFor="let win of quick_wins_array"
          >
            <div class="design-v2-flex-quick-fixes-item-icon">
              <i class="fa-solid fa-circle-check"></i>
            </div>
            <div class="design-v2-flex-quick-fixes-item-text">
              <h3>{{ win.quick_win_title }}</h3>
              <p>{{ win.quick_win_description }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div
      class="design-v2-flex"
      *ngIf="page_bins?.length > 0 || backlink_bins?.length > 0"
    >
      <div class="design-v2-flex-item" *ngIf="page_bins?.length > 0">
        <h2 class="design-v2-flex-item-headline">Content Score Distribution</h2>
        <div class="design-v2-horizontal-barchart-container">
          <div
            class="design-v2-horizontal-barchart"
            *ngFor="let bin of page_bins"
          >
            <div class="design-v2-horizontal-barchart-bar-label">
              {{ bin.name }}
            </div>
            <div class="design-v2-horizontal-barchart-bar-container">
              <div
                class="design-v2-horizontal-barchart-bar"
                [ngStyle]="{
                  width: bin.horizontal_percentage + '%',
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
      <div class="design-v2-flex-item" *ngIf="backlink_bins?.length > 0">
        <h2 class="design-v2-flex-item-headline">Backlink Content Score</h2>
        <div class="design-v2-horizontal-barchart-container">
          <div
            class="design-v2-horizontal-barchart"
            *ngFor="let bin of backlink_bins"
          >
            <div class="design-v2-horizontal-barchart-bar-label">
              {{ bin.name }}
            </div>
            <div class="design-v2-horizontal-barchart-bar-container">
              <div
                class="design-v2-horizontal-barchart-bar"
                [ngStyle]="{
                  width: bin.percentage + '%',
                }"
              ></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <ng-container *ngIf="showCustomChart">
    <div class="design-v2-flex">
      <div class="design-v2-flex-item">
        <div
          class="design-v2-flex-item-container"
          style="margin-top: 5px; display: block"
        >
          <app-custom-barchart
            [isViewAllActiveProject]="false"
            [barchartInputData]="barChartOutputData"
            (barchartClicked)="barchartClicked($event)"
            (competitorUrlChanged)="competitorUrlChanged($event)"
            (factorChange)="factorChange($event)"
            [cardName]="cardName"
            [keywordData]="keywordDataInsights"
            [selectedCard]="selectedCard"
            [isFreemiumUser]="false"
            (constructFixes)="constructFixes($event)"
          ></app-custom-barchart>
        </div>
      </div>
    </div>
  </ng-container>

  <div
    class="ai_analysis_gr_container ai_analysis_overview_scroll"
    *ngIf="showBacklinkOnlyTable"
  >
    <div class="design-v2-flex" style="width: 100%; margin: 0">
      <div class="design-v2-flex-item">
        <div class="design-v2-flex-item-container" style="margin: 0">
          <div
            class="seo-ai_analysis-backlinks-table_container"
            style="margin-top: 0; padding-top: 0; width: 100%"
          >
            <div
              style="
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 15px;
              "
            >
              <div>
                <h2>
                  {{ "words.samples" | translate }}:
                  <span style="opacity: 0.6">
                    {{ renamedVariables?.[backLinkselectedVariable]?.name }}
                  </span>
                </h2>
              </div>
              <div
                class="position_tracking_header-filters"
                *ngIf="competitorExists"
              >
                <div class="custom_horizontal_option_select-container">
                  <div
                    class="custom_horizontal_option_active"
                    [ngStyle]="{
                      width: horizontalSingleOptionStyles.width,
                      transform: horizontalSingleOptionStyles.transform,
                    }"
                  ></div>
                  <div
                    class="custom_horizontal_option_select"
                    *ngFor="let item of horizontalSingleSelectOptions"
                    (click)="
                      onToggleChange($event, item, horizontalSingleOptionStyles)
                    "
                  >
                    <p>
                      {{ "words." + item.value | translate }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="hover-unhide">
              <div class="custom_table-container" style="margin-top: 10px">
                <table class="custom_table">
                  <thead>
                    <tr>
                      <th style="width: 200px" *ngIf="isViewAllActiveProject">
                        <div>
                          {{ "words.domain" | translate }}
                        </div>
                      </th>
                      <th class="maxWidth300">
                        <div *ngIf="tableVarianleOne">
                          {{ tableVarianleOne }}
                        </div>
                      </th>
                      <th>
                        <div *ngIf="tableVarianleTwo">
                          {{ tableVarianleTwo }}
                        </div>
                      </th>
                      <th style="width: 160px" *ngIf="show_ai_score_column">
                        <div>
                          {{ "words.ranking_impact" | translate }}
                          <svg
                            (click)="sortByRankingImpact()"
                            class="custom_table_sort-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            [ngClass]="{
                              active: sortByRankingImpactTrigger,
                            }"
                          >
                            <g clip-path="url(#clip0_1676_4762)">
                              <path
                                d="M12 8V15"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1676_4762">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </th>
                      <th style="width: 160px">
                        <div
                          matTooltip="{{
                            'phrases.a_measure_of_how_closely_your_content_matches_the_users_search_intent_and_query'
                              | translate
                          }}"
                          matTooltipPosition="above"
                        >
                          {{ "words.relevance_score" | translate }}
                          <svg
                            (click)="sortByRelevancyScore()"
                            class="custom_table_sort-icon"
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            [ngClass]="{
                              active: !sortByRelevancyScoreTrigger,
                            }"
                          >
                            <g clip-path="url(#clip0_1676_4762)">
                              <path
                                d="M12 8V15"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M16 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                              <path
                                d="M8 12L12 8"
                                stroke="black"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </g>
                            <defs>
                              <clipPath id="clip0_1676_4762">
                                <rect width="24" height="24" fill="white" />
                              </clipPath>
                            </defs>
                          </svg>
                        </div>
                      </th>
                      <th
                        style="width: 100px"
                        *ngIf="backlinkRelevanceTableActive"
                      >
                        <div>
                          {{ "words.backlink_url" | translate }}
                        </div>
                      </th>
                      <th style="width: 70px">
                        <div>{{ "words.url" | translate }}</div>
                      </th>

                      <th
                        style="width: 200px"
                        *ngIf="selectedFilterButton != 'competitor'"
                      >
                        <div>
                          <p style="visibility: hidden; margin: 0">
                            {{ "words.actions" | translate }}
                          </p>
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <ng-container
                      *ngIf="
                        backlinkOnlyTableData &&
                          backlinkOnlyTableData.length > 0;
                        else noTableData
                      "
                    >
                      <tr *ngFor="let item of backlinkOnlyTableData">
                        <td *ngIf="isViewAllActiveProject">
                          {{ item["domain"] }}
                        </td>
                        <td class="maxWidth300 cursor_pointer">
                          <ng-container *ngIf="!item.showMore">
                            <p
                              class="long-title"
                              matTooltip="{{ item['show_var1_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["show_var1_text"] }}
                            </p>
                          </ng-container>
                          <ng-container *ngIf="item.showMore">
                            <p
                              class="long-title"
                              matTooltip="{{ item['var1_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["var1_text"] }}
                            </p>
                          </ng-container>
                        </td>
                        <td
                          style="font-size: 0.8em"
                          class="maxWidth300 cursor_pointer"
                        >
                          <ng-container *ngIf="!item.showMore2">
                            <p
                              class="long-title"
                              matTooltip="{{ item['show_var2_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["show_var2_text"] }}
                            </p>
                          </ng-container>
                          <ng-container *ngIf="item.showMore2">
                            <p
                              class="long-title"
                              matTooltip="{{ item['var2_text'] }}"
                              matTooltipPosition="above"
                              style="margin: 0"
                            >
                              {{ item["var2_text"] }}
                            </p>
                          </ng-container>
                        </td>
                        <td
                          *ngIf="show_ai_score_column"
                          style="font-size: 0.8em"
                          class="table_ai_score_value"
                          [class.low_value]="item.AI_score < 70"
                          [class.mid_value]="
                            item.AI_score >= 70 && item.AI_score < 85
                          "
                          [class.high_value]="item.AI_score >= 85"
                        >
                          {{ item["AI_score"]
                          }}<span
                            style="
                              color: var(--text-main-color);
                              opacity: 0.5;
                              font-size: 8px;
                            "
                            >/100</span
                          >
                        </td>
                        <td style="font-size: 0.8em">
                          {{
                            formatPercentage(
                              item[this.backLinkselectedVariable] || 0
                            )
                          }}
                        </td>
                        <td
                          *ngIf="backlinkRelevanceTableActive"
                          style="cursor: pointer"
                          (click)="openInNewTab(item.var2_linkfull, item)"
                          [matTooltip]="item.var2_linkfull"
                          matTooltipPosition="above"
                        >
                          <svg
                            viewBox="0 0 640 512"
                            style="
                              min-width: 16px;
                              width: 16px;
                              fill: var(--navmenu-icon-svg-color);
                            "
                          >
                            <path
                              d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                            />
                          </svg>
                        </td>
                        <td
                          style="cursor: pointer"
                          (click)="openInNewTab(item.var1_link, item)"
                          [matTooltip]="item.var1_link"
                          matTooltipPosition="above"
                        >
                          <svg
                            viewBox="0 0 640 512"
                            style="
                              min-width: 16px;
                              width: 16px;
                              fill: var(--navmenu-icon-svg-color);
                            "
                          >
                            <path
                              d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                            />
                          </svg>
                        </td>

                        <td
                          style="text-align: right"
                          *ngIf="selectedFilterButton != 'competitor'"
                        >
                          <div style="display: flex; align-items: center">
                            <!-- <p
                                        (click)="viewMore(item)"
                                        style="
                                          color: var(
                                            --accent-theme-color2
                                          ) !important;
                                          margin: 0;
                                          cursor: pointer;
                                          text-align: right;
                                          font-size: 0.9em;
                                          display: inline-block;
                                          white-space: nowrap;
                                        "
                                      >
                                        {{ "words.view_more" | translate }}
                                      </p> -->
                            <button
                              mat-raised-button
                              type="button"
                              class="btn_withoutIcon custom-button"
                              (click)="openAiEditor(item)"
                              style="
                                margin: 0 0 0 auto;
                                border: none !important;
                                background: transparent !important;
                                display: inline-block;
                              "
                            >
                              <span
                                style="
                                  margin-right: 0px;
                                  top: 1px;
                                  position: relative;
                                  white-space: nowrap;
                                "
                              >
                                {{ "words.ai_editor" | translate }}
                              </span>
                            </button>
                          </div>
                        </td>
                      </tr>
                    </ng-container>
                    <ng-template #noTableData>
                      <tr>
                        <td colspan="10">
                          {{ "phrases.no_data_found" | translate }}
                        </td>
                      </tr>
                    </ng-template>
                  </tbody>
                </table>
              </div>
              <div class="general-hide-scrollbar"></div>
              <!-- Loader Overlay -->
              <div
                class="loading-bug-data-overlay"
                *ngIf="isLoadingBacklinkTable"
              >
                <mat-progress-bar mode="indeterminate"></mat-progress-bar>
              </div>
            </div>
            <ng-container *ngIf="backlinkTotalCount > 10">
              <div class="paginator_with_pageOptions_container">
                <mat-form-field
                  class="bhm-option-container-1"
                  style="
                    --label-name: &quot;&quot;;
                    --form-field-infix-width: 150px;
                  "
                >
                  <mat-select
                    [(ngModel)]="pageSize"
                    (selectionChange)="onPageChange2($event)"
                  >
                    <mat-option
                      class="bhm-option-select-option-1"
                      *ngFor="let size of pageSizeOptions"
                      [value]="size"
                    >
                      {{ size }}
                      {{ "phrases.results_per_page" | translate }}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <mat-paginator
                  [pageSize]="pageSize"
                  [pageSizeOptions]="pageSizeOptions"
                  [length]="dataSource.data.length"
                  (page)="onPageChange($event)"
                  [pageIndex]="pageIndex"
                ></mat-paginator>
              </div>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="ai_analysis_gr_container" *ngIf="showInternalLinkOnlyTable">
    <div
      class="seo-ai_analysis-backlinks-table_container"
      style="
        margin-top: 20px;
        border-top: 1px solid var(--border-color-theme);
        padding-top: 20px;
        width: 100%;
      "
    >
      <div
        style="
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-bottom: 15px;
        "
      >
        <div>
          <h2 style="margin: 0; font-size: 19px; font-weight: 400">
            {{ "words.samples" | translate }}:
            <span style="opacity: 0.6">
              {{ renamedVariables?.[backLinkselectedVariable]?.name }}
            </span>
          </h2>
        </div>
        <div class="position_tracking_header-filters">
          <div class="custom_horizontal_option_select-container">
            <div
              class="custom_horizontal_option_active"
              [ngStyle]="{
                width: horizontalSingleOptionStyles.width,
                transform: horizontalSingleOptionStyles.transform,
              }"
            ></div>
            <div
              class="custom_horizontal_option_select"
              *ngFor="let item of horizontalSingleSelectOptions"
              (click)="
                onToggleChange($event, item, horizontalSingleOptionStyles)
              "
            >
              <p>
                {{ "words." + item.value | translate }}
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="hover-unhide">
        <div class="custom_table-container" style="margin-top: 10px">
          <table class="custom_table">
            <thead>
              <tr>
                <th style="width: 200px" *ngIf="isViewAllActiveProject">
                  <div>{{ "words.domain" | translate }}</div>
                </th>
                <th class="maxWidth300">
                  <div>{{ "words.page_title" | translate }}</div>
                </th>
                <th style="width: 160px">
                  <div *ngIf="this.backLinkselectedVariable == 'distance'">
                    {{ "words.distance" | translate }}
                    <svg
                      (click)="sortByDistance()"
                      class="custom_table_sort-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      [ngClass]="{
                        active: !sortByDistanceTrigger,
                      }"
                    >
                      <g clip-path="url(#clip0_1676_4762)">
                        <path
                          d="M12 8V15"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1676_4762">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                  <div *ngIf="this.backLinkselectedVariable == 'pr'">
                    {{ "words.page_rank" | translate }}
                    <svg
                      (click)="sortByPageRank()"
                      class="custom_table_sort-icon"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      [ngClass]="{
                        active: !sortByPageRankTrigger,
                      }"
                    >
                      <g clip-path="url(#clip0_1676_4762)">
                        <path
                          d="M12 8V15"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M16 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                        <path
                          d="M8 12L12 8"
                          stroke="black"
                          stroke-width="1.5"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_1676_4762">
                          <rect width="24" height="24" fill="white" />
                        </clipPath>
                      </defs>
                    </svg>
                  </div>
                </th>
                <th style="width: 100px">
                  <div>{{ "words.url" | translate }}</div>
                </th>
                <th
                  style="width: 200px"
                  *ngIf="selectedFilterButton != 'competitor'"
                >
                  <div>
                    <p style="visibility: hidden; margin: 0">
                      {{ "words.actions" | translate }}
                    </p>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngIf="internalLinkingDataTable.length > 0; else noTableData"
              >
                <tr *ngFor="let item of internalLinkingDataTable">
                  <td *ngIf="isViewAllActiveProject">
                    {{ item["domain"] }}
                  </td>
                  <td class="maxWidth300 cursor_pointer">
                    <div
                      [matTooltip]="item.title"
                      *ngIf="item.distance != 0"
                      class="long-title"
                    >
                      {{ item["show_title"] }}
                    </div>
                    <div *ngIf="item.distance === 0">/</div>
                  </td>
                  <td>
                    <ng-container
                      *ngIf="this.backLinkselectedVariable == 'distance'"
                    >
                      {{ item["distance"] }}
                    </ng-container>
                    <ng-container *ngIf="this.backLinkselectedVariable == 'pr'">
                      {{ formatPageRank(item["page_rank"]) }}
                    </ng-container>
                  </td>
                  <td
                    style="cursor: pointer"
                    (click)="openInNewTab(item.url, item)"
                    [matTooltip]="item.url"
                    matTooltipPosition="above"
                  >
                    <svg
                      viewBox="0 0 640 512"
                      style="
                        min-width: 16px;
                        width: 16px;
                        fill: var(--navmenu-icon-svg-color);
                      "
                    >
                      <path
                        d="M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z"
                      />
                    </svg>
                  </td>
                  <td style="text-align: right">
                    <!-- <p
                                  (click)="viewMore(item)"
                                  style="
                                    color: var(
                                      --accent-theme-color2
                                    ) !important;
                                    margin: 0;
                                    cursor: pointer;
                                    text-align: right;
                                    font-size: 0.9em;
                                    display: inline-block;
                                  "
                                >
                                  View more
                                </p> -->
                    <button
                      mat-raised-button
                      type="button"
                      class="btn_withoutIcon custom-button"
                      (click)="openAiEditor(item)"
                      style="
                        margin: 0 auto;
                        border: none !important;
                        background: transparent !important;
                        display: inline-block;
                        margin-left: 14px;
                      "
                    >
                      <span
                        style="margin-right: 0px; top: 1px; position: relative"
                      >
                        {{ "words.fix_it_here" | translate }}
                      </span>
                    </button>
                  </td>
                </tr>
              </ng-container>
              <ng-template #noTableData>
                <tr>
                  <td colspan="10">
                    {{ "phrases.no_data_found" | translate }}
                  </td>
                </tr>
              </ng-template>
            </tbody>
          </table>
        </div>
        <div class="general-hide-scrollbar"></div>
        <!-- Loader Overlay -->
        <div class="loading-bug-data-overlay" *ngIf="isLoadingBacklinkTable">
          <mat-progress-bar mode="indeterminate"></mat-progress-bar>
        </div>
      </div>
      <ng-container *ngIf="internalTotalCount > 10">
        <div class="paginator_with_pageOptions_container">
          <mat-form-field
            class="bhm-option-container-1"
            style="--label-name: &quot;&quot;; --form-field-infix-width: 150px"
          >
            <mat-select
              [(ngModel)]="pageSize"
              (selectionChange)="onPageChange2($event)"
            >
              <mat-option
                class="bhm-option-select-option-1"
                *ngFor="let size of pageSizeOptions"
                [value]="size"
              >
                {{ size }}
                {{ "phrases.results_per_page" | translate }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-paginator
            [pageSize]="pageSize"
            [pageSizeOptions]="pageSizeOptions"
            [length]="dataSource.data.length"
            (page)="onPageChange($event)"
            [pageIndex]="pageIndex"
          ></mat-paginator>
        </div>
      </ng-container>
    </div>
  </div>

  <div
    class="loading-data-overlay"
    *ngIf="isLoadingBacklinkTable || showLoader"
  >
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>
<div *ngIf="firstLoad">
  <div style="display: flex; gap: 40px">
    <div class="bar-chart-box" style="width: 100%" fxLayout="column">
      <ngx-skeleton-loader
        count="1"
        [theme]="{
          height: '180px',
          outline: 'none',
          'background-color': '#37474f1a',
        }"
      ></ngx-skeleton-loader>
    </div>
  </div>
  <div class="bar-chart-box" style="margin-top: 30px" fxLayout="column">
    <ngx-skeleton-loader
      count="1"
      [theme]="{
        height: '220px',
        outline: 'none',
        'background-color': '#37474f1a',
      }"
    ></ngx-skeleton-loader>
  </div>
</div>
